{
  "MeasurementsFilterField": {
    "operators": {
      "gt": "Greater than",
      "eq": "Equals",
      "lt": "Less than"
    },
    "units": {
      "cm_long": "Metric (cm)",
      "cm": "cm",
      "in_long": "Imperial (in)",
      "in": "in",
      "m_long": "Metric (m)",
      "m": "m",
      "ft_long": "Imperial (ft)",
      "ft": "ft"
    }
  }
}
